import React from 'react';
import { Link } from 'react-router-dom';

import '../../styles/industries.css';

import consumerTechImg from '../../assets/consumer-tech.jpg';
import humanResourcesImg from '../../assets/human-resources.jpg';
import aiImg from '../../assets/artificial-intelligence.jpg';
import bankingImg from '../../assets/banking.jpg';
import healthcareImg from '../../assets/healthcare.jpg';
import travelImg from '../../assets/travel.jpg';
import mediaEntertainmentImg from '../../assets/entertainment.jpg';

const industries = [
  {
    title: "Consumer Tech",
    description: "D2C platforms for consumer products, retail systems, sales analytics, and B2B commerce solutions.",
    img: consumerTechImg,
    route: "/industries/consumer-tech"
  },
  {
    title: "Human Resources",
    description: "Human Capital Management (HCM), Payroll Automation, and complete Employee Management systems.",
    img: humanResourcesImg,
    route: "/industries/human-resources"
  },
  {
    title: "Artificial Intelligence",
    description: "Solutions including Optical Character Recognition (OCR), Computer Vision, and smart automation.",
    img: aiImg,
    route: "/industries/artificial-intelligence"
  },
  {
    title: "Banking",
    description: "Banking platforms, digital wallets, secure payment gateways, and financial integration solutions.",
    img: bankingImg,
    route: "/industries/banking"
  },
  {
    title: "Healthcare",
    description: "Hospital Management Systems, Medical Record Systems, and Telemedicine-ready platforms.",
    img: healthcareImg,
    route: "/industries/healthcare"
  },
  {
    title: "Travel",
    description: "Intelligent travel guides, hotel booking systems, logistics, and multi-platform travel apps.",
    img: travelImg,
    route: "/industries/travel"
  },
  {
    title: "Media & Entertainment",
    description: "Streaming solutions, OTT platforms, content distribution tools, and social media integrations.",
    img: mediaEntertainmentImg,
    route: "/industries/media-entertainment"
  }
];

const Industries = () => {
  return (
    <div className="industries-container">
      <h1 className="industries-heading">Industries We Serve</h1>
      <p className="industries-intro">
        At NEELAverse Technologies, we build robust solutions for diverse industries through digital innovation, automation, and intelligent platforms.
      </p>

      <div className="industries-grid">
        {industries.map((industry, index) => (
          <Link to={industry.route} className="industry-card" key={index}>
            <img src={industry.img} alt={industry.title} className="industry-image" />
            <div className="industry-info">
              <h3>{industry.title}</h3>
              <p>{industry.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Industries;
